import React from 'react';
import { observer } from 'mobx-react';
import Box from '@material-ui/core/Box';
import WelcomeSection from './sections/Welcome';
import ThemeSection from './sections/Themes';
import FundingSection from './sections/Funding';
import ConsumerSection from './sections/Consumer';
import ExpertsSection from './sections/Experts';
import GallerySection from './sections/Gallery';
import NewsletterSection from './sections/Newsletter';
import CardsSection from './sections/Cards';
import AboutSection from './sections/About';
import ShopSection from './sections/Shop';
import useStores from '../../utils/useStores';

const img1 = '/home/unsere-heizung-campaign-images/img1.jpg';
const img2 = '/home/unsere-heizung-campaign-images/img2.jpg';
const img3 = '/home/unsere-heizung-campaign-images/img3.jpg';
const img4 = '/home/unsere-heizung-campaign-images/img4.jpg';
const img5 = '/home/unsere-heizung-campaign-images/img5.jpg';

const unsereHeizungImages = [img1, img2, img3, img4, img5];

unsereHeizungImages.push(img1);
unsereHeizungImages.push(img2);
unsereHeizungImages.unshift(img5);
unsereHeizungImages.unshift(img4);

const eLearningImg1 = '/elearning/Pellets_Modul_0.png';
const eLearningImg2 = '/elearning/Pellets_Modul_1.png';
const eLearningImg3 = '/elearning/Pellets_Modul_2.png';
const eLearningImg4 = '/elearning/Pellets_Modul_3.png';

const elearningImages = [
  eLearningImg1,
  eLearningImg2,
  eLearningImg3,
  eLearningImg4,
];

elearningImages.push(eLearningImg1);
elearningImages.push(eLearningImg2);
elearningImages.unshift(eLearningImg4);
elearningImages.unshift(eLearningImg3);

const HomeView = () => {
  const { dataStore } = useStores();
  const linkContext = process.env.NODE_ENV === 'production' ? '/' : `/depi/`;
  return (
    <Box>
      <WelcomeSection />
      <ThemeSection />
      <FundingSection />
      <GallerySection images={unsereHeizungImages} />
      <ConsumerSection />
      <ExpertsSection />
      <GallerySection
        images={elearningImages}
        LinkComponent="a"
        LinkProps={{
          href: 'https://www.grüne-wärme.info',
          target: '_blank',
          rel: 'noopener noreferrer',
        }}
      />
      <CardsSection
        label="News und Presse"
        data={dataStore.pages.latestNews}
        href={`${linkContext}news-und-pressemitteilungen`}
      />
      <CardsSection
        label="Termine"
        data={dataStore.pages.latestEvents}
        href={`${linkContext}termine`}
      />
      <NewsletterSection />
      <AboutSection />
      <ShopSection />
    </Box>
  );
};

export default observer(HomeView);
